import { render, staticRenderFns } from "./add-space-dialog.vue?vue&type=template&id=a8afcd02&"
import script from "./add-space-dialog.vue?vue&type=script&lang=ts&"
export * from "./add-space-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./add-space-dialog.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports